import { GoEye } from "react-icons/go";
import { formatDate } from '../../../../../utils/dateFormat';
export { formatDate };

// Annual Vacation Status renderer with proper styling
export const renderAnnualVacationStatus = (item) => {
  let statusText = '';
  let statusStyle = 'px-2 py-1 rounded-full text-base';

  if (item.Annual_vacation_status) {
    // Truncate long status text (15 characters like original)
    statusText = item.Annual_vacation_status.length > 15 
      ? `${item.Annual_vacation_status.substring(0, 15)}...`
      : item.Annual_vacation_status;
    
    // Style based on status
    switch (item.Annual_vacation_status) {
      case 'ON ERE-ANNUAL VACATION':
        statusStyle += ' bg-blue-100 text-blue-800';
        break;
      case 'ERE ISSUED':
        statusStyle += ' bg-green-100 text-green-800';
        break;
      case 'ERE EXTENSION':
      case 'ON ERE EXTENSION_ISSUED':
        statusStyle += ' bg-purple-100 text-purple-800';
        break;
      case 'ERE EXTENSION-PAYMENT DONE':
        statusStyle += ' bg-green-100 text-green-800';
        break;
      case 'ON ERE-ANNUAL VACATION-PAYMENT DONE':
        statusStyle += ' bg-green-100 text-green-800';
        break;
      case 'ON ERE-PENDING PAYMENT':
        statusStyle += ' bg-yellow-100 text-yellow-800';
        break;
      default:
        statusStyle += ' bg-gray-100 text-gray-800';
    }
  } else {
    // Fallback to demobilization_type
    statusText = item.demobilization_type || 'ERE-ANNUAL VACATION';
    statusStyle += ' bg-gray-100 text-gray-800';
  }

  return (
    <span className={statusStyle} title={item.Annual_vacation_status}>
      {statusText}
    </span>
  );
};

// Action button renderer for Annual Vacation
export const renderAnnualVacationActionButton = (item, handleEreClick, handleExtensionClick) => {
  const isExtensionStatus = [
    "ERE EXTENSION",
    "ON ERE EXTENSION_ISSUED", 
    "ERE EXTENSION-PAYMENT DONE"
  ].includes(item.Annual_vacation_status);

  const isDisabled = item.Annual_vacation_Fees === "TO BE PAID";

  const handleButtonClick = () => {
    if (isExtensionStatus) {
      handleExtensionClick(item);
    } else {
      handleEreClick(item);
    }
  };

  return (
    <button
      onClick={handleButtonClick}
      disabled={isDisabled}
      className={`ml-2 ${isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
      style={{
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.5 : 1
      }}
    >
      <GoEye fontSize={22} />
    </button>
  );
};

// Memoized columns configuration
export const ERE_ANNUAL_VACATION_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'EMPLOYEE NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'total_salary', title: 'TOTAL SALARY', searchable: false },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  { key: 'iqama_expiry_date_g', title: 'IQAMA EXPIRY DATE', searchable: false },
  { key: 'arrival_date', title: 'ARRIVAL DATE', searchable: false },
  { key: 'mobilization_date', title: 'MOBILIZATION DATE', searchable: false },
  { key: 'demobilization_date', title: 'DEMOBILIZATION DATE', searchable: false },
  { key: 'demobilization_comments', title: 'DEMOBILIZATION COMMENTS', searchable: false },
  { key: 'idle_aging', title: 'IDLE AGING', searchable: false },
  { key: 'Annual_entry_before', title: ' ENTRY BEFORE DATE', searchable: false },
  { key: 'Annual_vacation_status', title: 'STATUS', searchable: true },
  { key: 'action', title: 'ACTION', searchable: false }
];

// Constants for better maintainability
export const ERE_ANNUAL_VACATION_CONFIG = {
  API_ENDPOINT: "/demobilization/idleCandidates/ERE-ANNUAL VACATION",
  DOWNLOAD_ENDPOINT: "/demobilization/idleCandidates/download/ERE-ANNUAL VACATION", 
  DOWNLOAD_FILENAME: "ERE_Annual_summary",
  SEARCH_PLACEHOLDER: "Search Annual Vacation employees...",
  NO_DATA_MESSAGE: "No Annual Vacation employees found",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000],
  UPDATE_ANNUAL_VACATION_ENDPOINT: "/employeeAnnualvacation/updateAnnualByDate"
};

// Memoized searchable fields derived from columns
export const ERE_ANNUAL_VACATION_SEARCHABLE_FIELDS = ERE_ANNUAL_VACATION_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);

// Annual Vacation Status constants for validation and logic
export const ANNUAL_VACATION_STATUS_TYPES = {
  ON_ERE_ANNUAL_VACATION: "ON ERE-ANNUAL VACATION",
  ERE_ISSUED: "ERE ISSUED", 
  ERE_EXTENSION: "ERE EXTENSION",
  ON_ERE_EXTENSION_ISSUED: "ON ERE EXTENSION_ISSUED",
  ERE_EXTENSION_PAYMENT_DONE: "ERE EXTENSION-PAYMENT DONE",
  ON_ERE_ANNUAL_VACATION_PAYMENT_DONE: "ON ERE-ANNUAL VACATION-PAYMENT DONE",
  ON_ERE_PENDING_PAYMENT: "ON ERE-PENDING PAYMENT"
};

// Extension status types for conditional logic
export const ANNUAL_VACATION_EXTENSION_STATUSES = [
  ANNUAL_VACATION_STATUS_TYPES.ERE_EXTENSION,
  ANNUAL_VACATION_STATUS_TYPES.ON_ERE_EXTENSION_ISSUED,
  ANNUAL_VACATION_STATUS_TYPES.ERE_EXTENSION_PAYMENT_DONE
];

// Search key fields for the old search functionality (to maintain compatibility)
export const ANNUAL_VACATION_SEARCH_KEYS = [
  "employee_id",
  "visa_reference_number", 
  "border_number"
];